import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PlatformRoute from '../../auth/PlatformRoute';
import './MvpTalent.css';
import AuditPage from './pages/AuditPage';
import DashboardPage from './pages/DashboardPage';
import InstanceDetailPage from './pages/InstanceDetailPage';
import InstancesPage from './pages/InstancesPage';
import NotificationsPage from './pages/NotificationsPage';
import SecurityPage from './pages/SecurityPage';
import SettingsPage from './pages/SettingsPage';
import TalentDetailPage from './pages/TalentDetailPage';
import TalentListPage from './pages/TalentListPage';
import WorkDetailPage from './pages/WorkDetailPage';
import WorkListPage from './pages/WorkListPage';

const MvpTalentModule: React.FC = () => {
  return (
    <PlatformRoute>
      <Routes>
        <Route index element={<DashboardPage />} />
        <Route path="talent" element={<TalentListPage />} />
        <Route path="talent/:memberId" element={<TalentDetailPage />} />
        <Route path="instances" element={<InstancesPage />} />
        <Route path="instances/:instanceId" element={<InstanceDetailPage />} />
        <Route path="work" element={<WorkListPage />} />
        <Route path="work/:requestId" element={<WorkDetailPage />} />
        <Route path="notifications" element={<PlatformRoute><NotificationsPage /></PlatformRoute>} />
        <Route path="security" element={<PlatformRoute><SecurityPage /></PlatformRoute>} />
        <Route path="audit" element={<PlatformRoute><AuditPage /></PlatformRoute>} />
        <Route path="settings" element={<PlatformRoute><SettingsPage /></PlatformRoute>} />
        <Route path="*" element={<Navigate to="/command-center/mvp-talent" replace />} />
      </Routes>
    </PlatformRoute>
  );
};

export default MvpTalentModule;
